import React, { useRef } from 'react';
import ReactDatePicker from 'react-datepicker';

import { getClassNames } from '../../../../utils/util';

import { ReactComponent as CalendarIcon } from '../../../../resources/icons/calendar.svg';

import './date-picker.scss';
import 'react-datepicker/dist/react-datepicker.css';

type Props = {
  label?: string;
  name?: string;
  value?: Date | null;
  onChange: (date: Date) => void;
  disabled?: boolean;
  inline?: boolean;
  minDate?: Date;
  maxDate?: Date;
};

const DatePicker = ({ label, name, value, onChange, disabled = false, inline = false, minDate, maxDate }: Props) => {
  // Cannot find type definition from react-datepicker
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const datePickerRef = useRef<any>();

  const handleChange = (date: Date) => {
    const newDate: Date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    onChange(newDate);
  };

  const handleIconClick = () => {
    if (!datePickerRef.current) return;

    datePickerRef.current.setOpen(true);
  };

  return (
    <div className="date-picker">
      {!inline && (
        <div className="date-picker__label-container">
          <label htmlFor={name}>{label}</label>
        </div>
      )}
      <div className={getClassNames('date-picker__input-container', { disabled, inline })} data-testid="date-picker">
        <ReactDatePicker
          id={name}
          selected={value}
          onChange={handleChange}
          dateFormat="d MMMM yyyy"
          ref={datePickerRef}
          showPopperArrow={false}
          disabled={disabled}
          autoComplete="off"
          inline={inline}
          minDate={minDate}
          maxDate={maxDate}
        />
        {!inline && (
          <div>
            <CalendarIcon
              className={getClassNames('date-picker__icon', { disabled })}
              onClick={handleIconClick}
              data-testid="date-picker-icon"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DatePicker;
